export default function getMetaValue(name: string): string {
  const metaTag = document.querySelector(`meta[name=${name}]`)

  if (metaTag !== null) {
    return metaTag.getAttribute('content') as string
  }

  return ''
}
